// Constants
/** Class to handle serialization/deserialization for status tables*/ export class StoreEntityStatusSerializationHandler {
    /** serialize to IStoreEntityStatusPersistedResource */ toSerializable(key, value) {
        return {
            key: key,
            status: value
        };
    }
    /** build StoreEntityStatus from IStoreEntityStatusPersistedResource */ fromSerializable(key, serializableValue) {
        return serializableValue.status;
    }
}
